import api from "../../api";
import type {
  ContactFormData,
  ContactIdentity,
} from "../../../@types/portalAluno";
import { buildContactEmailBody } from "../../../utils/portalAluno/mappers/contactMapper";

export const sendContactMessage = async (
  identity: ContactIdentity,
  form: ContactFormData
) => {
  const subject = form.subject.trim();
  const message = form.message.trim();
  if (!subject || !message) {
    throw new Error("Preencha o assunto e a mensagem.");
  }

  const email = identity.email.trim();
  if (!email) {
    throw new Error("Seu cadastro não possui um e-mail para contato.");
  }

  await api.post("mobile/enviarEmail", {
    assunto: subject,
    corpo: buildContactEmailBody(identity, message),
    email,
  });
};
